import {useMemo} from 'react';

import {css, view} from '@sail/ui';

import {ChatRowContainer} from '@stripe-internal/conversations-ui';
import type {MetaEventStyle} from '@stripe-internal/conversations-client';

export type Props = {
  style?: MetaEventStyle;
  children: React.ReactNode;
};

// The selected dot-com branch intentionally ignores the requested style.
const getStyles = (_style?: MetaEventStyle) =>
  css({
    textAlign: 'center',
    font: 'label.small',
    textColor: 'subdued',
  });

export const MetaRow = ({style, children}: Props) => {
  const styles = useMemo(() => getStyles(style), [style]);

  return (
    <view.div data-testid="meta-row">
      <ChatRowContainer position="center">
        <view.div uses={[styles]}>{children}</view.div>
      </ChatRowContainer>
    </view.div>
  );
};
